import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Heart } from 'lucide-react';
import { navigationItems, siteConfig } from '../../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (href) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  const mainNavItems = navigationItems.filter(item => 
    !['News', 'Contact'].includes(item.label)
  );

  return (
    <header className="main-header">
      <nav className="nav-wrapper">
        <Link to="/" className="nav-logo">
          <Heart size={20} fill="#D3FF62" color="#D3FF62" />
          {siteConfig.name}
        </Link>
        
        <div className="nav-links">
          {mainNavItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`nav-link ${isActive(item.href) ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
          <Link to="/donate" className="nav-cta">
            Donate
          </Link>
        </div>

        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div 
          style={{
            position: 'fixed',
            top: '72px',
            left: '12px',
            right: '12px',
            background: 'var(--brand-dark)',
            borderRadius: '16px',
            padding: '16px',
            zIndex: 99998,
            boxShadow: '0 8px 32px rgba(0, 69, 52, 0.3)'
          }}
        >
          {navigationItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className="nav-link"
              style={{ display: 'block', padding: '12px 16px' }}
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/donate"
            className="nav-cta"
            style={{ display: 'block', textAlign: 'center', marginTop: '12px' }}
            onClick={() => setMobileMenuOpen(false)}
          >
            Donate Now
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
